import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import { createSelector } from 'reselect';
import lodash from 'lodash';
import { IPumpingStationMotorMounting } from '../../../../@types/model/masterData/pumpingStation/motorMounting';
import { IRootState } from '../../../../@types/redux';
import { connect } from 'react-redux';
import MasterDataPumpingStationMotorMountingFunctions from '../../../../store/masterData/pumpingStation/motorMounting/functions';

interface IPumpingStationMotorMountingSelectorProps {
    value : string;
    disabled ?: boolean;
    className ?: string;
    required ?: boolean;
    onChange : (value : string) => void;

    isLoading : boolean;
    motorMountings : Array<IPumpingStationMotorMounting>;
}

interface IPumpingStationMotorMountingSelectorState { }

class PumpingStationMotorMountingSelectorComponent extends React.Component<IPumpingStationMotorMountingSelectorProps, IPumpingStationMotorMountingSelectorState> {
    constructor(props : IPumpingStationMotorMountingSelectorProps) {
        super(props);

        this.state = {};
    }

    public componentDidMount() {
        MasterDataPumpingStationMotorMountingFunctions.load();
    }

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : string;
    } | null | undefined) => {
        this.props.onChange(value?.value ?? '');
    };

    private readonly getData = (state : IPumpingStationMotorMountingSelectorState, props : IPumpingStationMotorMountingSelectorProps) => props.motorMountings;
    private readonly getValue = (state : IPumpingStationMotorMountingSelectorState, props : IPumpingStationMotorMountingSelectorProps) => props.value;
    private readonly getRequired = (state : IPumpingStationMotorMountingSelectorState, props : IPumpingStationMotorMountingSelectorProps) => props.required;

    private readonly getMotorMountings = createSelector([
        this.getData,
    ], (motorMountings) => motorMountings.filter(x => x.isActive).map(x => x.name).sort());

    private readonly getMotorMountingsForDropdown = createSelector([ 
        this.getRequired, this.getMotorMountings,
    ], (required, motorMountings) => {
        
        const dropdownData = lodash.map(motorMountings, (element) => ({ label: element, value: element }));
        
        if (!required) {
            dropdownData.unshift({
                label: 'ALL',
                value: '',
            });
        }

        return dropdownData;
    });

    private readonly getSelectedValue = createSelector([ 
        this.getValue, this.getRequired, this.getMotorMountings,
    ], (value, required, motorMountings) => {
        if (value) {
            const motorMounting = motorMountings.find(element => element === value);

            if (motorMounting) {
                return { label: motorMounting, value: motorMounting };
            } else {
                return { label: value, value };
            }
        }

        if (!value && !required) {
            return {
                label: 'ALL',
                value: '',
            };
        }

        return null;
    });

    public readonly render = () => {
        const { required, className, disabled } = this.props;

        const dropdownData = this.getMotorMountingsForDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);

        return (
            <FormControl margin={'normal'} fullWidth className={className} disabled={disabled} error={required && !value}>
                <Autocomplete 
                    id={'motorMounting'}
                    options={dropdownData}
                    value={value}
                    getOptionSelected={(option, val) => option.value === val.value}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth label={'Motor Mount Type'} />}
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
            </FormControl>
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return { 
        isLoading: state.masterData.pumpingStation.motorMounting.isLoading,
        motorMountings: state.masterData.pumpingStation.motorMounting.motorMountings,
    };
};

const PumpingStationMotorMountingSelector = connect(
    mapStateToProps,
)(PumpingStationMotorMountingSelectorComponent);

export default PumpingStationMotorMountingSelector;